import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { ProjectChecklistProfileModule } from '@portal-core/project-checklists/components/project-checklist-profile/project-checklist-profile.module';
import { ProjectChecklistProfileDialogComponent } from './project-checklist-profile-dialog.component';

@NgModule({
  declarations: [ProjectChecklistProfileDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    ProjectChecklistProfileModule,
    LoaderModule,
    ErrorsExpansionPanelModule
  ],
  exports: [ProjectChecklistProfileDialogComponent]
})
export class ProjectChecklistProfileDialogModule { }
